import React from "react";
import FormationBookmarksPage from "./FormationBookmarksPage";

export default function BookmarksCollaborateur() {
    return <FormationBookmarksPage role="collaborateur" />;
}
